import { Button, Dropdown, Menu, message, Switch, Tooltip } from "antd";
import Modal from "antd/lib/modal/Modal";
import moment from "moment";
import "moment/locale/vi";
import ol from "openlayers";
import proj4 from "proj4";
import React from "react";
import { AxiosGetSecretApi } from "../../../utils/fetchApi/index";
import StaticClass from "../../../utils/staticClass";
import "../MapQuyHoach/map-quy-hoach.scss";

// import SearchResultDAQH from "././SearchResultDAQH";
proj4.defs(
  "EPSG:6959",
  "+proj=tmerc +lat_0=0 +lon_0=107.75 +k=0.9999 +x_0=500000 +y_0=0 +ellps=WGS84 +towgs84=-191.90441429,-39.30318279,-111.45032835,0.00928836,-0.01975479,0.00427372,0.252906278 +units=m +no_defs"
);
moment.locale("vi");
// const dateFormat = 'DD/MM/YYYY';
const domainMap = "https://gis-quyhoach.greenglobal.vn/arcgis/services";
class MapQuyHoach extends React.PureComponent {
  constructor(props) {
    super(props);
    this.map = {};
    this._layers = [];
    this._imgLayer = null;
    this._vectorLayer = null;

    this.state = {
      showProgressBar: false,
      _isShowFullImg: null,
      _isShowImgOverlay: false,
      loading: true,

      checkedVeTinh: false,
      checkedBanDo: false,
      checkedBanDoGiay: this.props.type === "KienTruc" ? false : true,
    };

    this._layers = [];
    this._vectorLayer = null;
    this._iconGeometry = null;

    this.BaseLayer = {
      RanhGioiDiaChinh: null,
      ThongTinDiaChinh: null,
      RanhGioiHanhChinh: null,
      BanDo64: null,
      BienSoNha: null,
      RanhGioiQuyHoach: null,
      TinhKhongSanBay2013: null,
      TinhKhongSanBay2010: null,

      // private
      QHCT_Polygon: null,
      QHCT_Line: null,
      QHCT_RanhGioi: null,

      QHPK_Polygon: null,
      QHPK_Line: null,
      QHPK_RanhGioi: null,

      QHC_Polygon: null,
      QHC_Line: null,

      KienTruc: null,
    };
  }

  async componentDidMount() {
    window.onbeforeunload = null;

    this.initMap();
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.isShowMenu !== this.props.isShowMenu) {
      if (this.map) {
        setTimeout(() => {
          this.map.updateSize();
        }, 1);
      }
    }

    if (
      prevProps.checkedBanDoGiay !== this.state.checkedBanDoGiay &&
      !this.state.checkedBanDoGiay
    ) {
      if (this._imgLayer) {
        this._imgLayer.setVisible(false);
        this._imgLayer = undefined;
      }
    }

    this.disableLayerBanDoGiay();
  }

  setLocation = (oo, zoom) => {
    this.map.getView().setCenter(oo);
    if (zoom) {
      this.map.getView().setZoom(zoom);
    }
    this._iconGeometry.setCoordinates(oo);
  };

  async initMap() {
    this.addPrivateLayers();
    let googleLayerS = new ol.layer.Tile({
      visible: false,
      preload: Infinity,
      source: new ol.source.TileImage({
        url: "https://mt0.google.com/vt/lyrs=y&hl=vi&x={x}&y={y}&z={z}&s=Ga",
        crossOrigin: "Anonymous",
      }),
    });

    let googleLayerB = new ol.layer.Tile({
      visible: false,
      source: new ol.source.OSM({
        url: "https://mt0.google.com/vt/lyrs=t,m&hl=vi&x={x}&y={y}&z={z}&s=",
        crossOrigin: "Anonymous",
        attributions: [
          new ol.Attribution({ html: "© Google" }),
          new ol.Attribution({
            html:
              '<a href="https://developers.google.com/maps/terms">Terms of Use.</a>',
          }),
        ],
      }),
    });

    this._layers.push(googleLayerB);
    this._layers.push(googleLayerS);
    
    if (this.props.type === "QHCT") {
      this._layers.push(this.BaseLayer.QHCT_Polygon);
      this._layers.push(this.BaseLayer.QHCT_Line);
      this._layers.push(this.BaseLayer.QHCT_RanhGioi);

      this._layers.push(this.BaseLayer.QHPK_RanhGioi);
    }

    if (this.props.type === "QHPK") {
      this._layers.push(this.BaseLayer.QHPK_Polygon);
      this._layers.push(this.BaseLayer.QHPK_Line);
      this._layers.push(this.BaseLayer.QHPK_RanhGioi);

      this._layers.push(this.BaseLayer.QHCT_RanhGioi);
    }

    if (this.props.type === "QHC") {
      this._layers.push(this.BaseLayer.QHC_Polygon);
      this._layers.push(this.BaseLayer.QHC_Line);

      this._layers.push(this.BaseLayer.QHCT_RanhGioi);
      this._layers.push(this.BaseLayer.QHPK_RanhGioi);

      // let res = await AxiosGetSecretApi
    }

    if (this.props.type === "KienTruc") {
      this._layers.push(this.BaseLayer.KienTruc);

      this._layers.push(this.BaseLayer.QHCT_RanhGioi);
      this._layers.push(this.BaseLayer.QHPK_RanhGioi);
    }

    this._iconGeometry = new ol.geom.Point([
      12045324.924720876,
      1806357.9277613866,
    ]);

    let iconFeature = new ol.Feature({
      geometry: this._iconGeometry,
      name: "Null Island",
      population: 4000,
      rainfall: 500,
    });

    let iconStyle = new ol.style.Style({
      image: new ol.style.Icon({
        anchor: [0.5, 1],
        anchorXUnits: "fraction",
        anchorYUnits: "fraction",
        opacity: 0.75,
        src: "Map-Marker-Bubble-Azure-icon.png",
        crossOrigin: "Anonymous",
      }),
    });

    iconFeature.setStyle(iconStyle);

    let vectorSource = new ol.source.Vector({
      features: [iconFeature],
    });

    let vectorLayer = new ol.layer.Vector({
      source: vectorSource,
    });
    vectorLayer.setZIndex(99);

    this._layers.push(vectorLayer)

    

    //end draw icon

    let container = document.getElementById("popup");
    let closer = document.getElementById("popup-closer");

    this._overlayPopup = new ol.Overlay({
      element: container,
      autoPan: true,
      autoPanAnimation: {
        duration: 250,
      },
    });
    let seft = this;
    closer.onclick = function () {
      seft._overlayPopup.setPosition(undefined);
      closer.blur();
      return false;
    };

    ///bat dau ve -------------------------------------------------------------------------------------------------------------
    let vector = new ol.layer.Vector({
      source: this.source,
      style: new ol.style.Style({
        fill: new ol.style.Fill({
          color: "rgba(255, 255, 255, 0.2)",
        }),
        stroke: new ol.style.Stroke({
          color: "#ffcc33",
          width: 2,
        }),
        image: new ol.style.Circle({
          radius: 7,
          fill: new ol.style.Fill({
            color: "#ffcc33",
          }),
        }),
      }),
    });

    this.map = new ol.Map({
      layers: [...this._layers, vector],
      loadTilesWhileInteracting: true,
      target: "map",
      view: new ol.View({
        code: "EPSG:10775",
        center: [12045324.924720876, 1806357.9277613866],
        zoom: 14,
        minZoom: 6,
        maxZoom: 20,
      }),
      overlays: [this._overlayPopup],
      controls: ol.control.defaults({
        attribution: false,
        zoom: true,
      }),
    });
    // het ------------------------------------------------------------------------------------------------------------------

    this.map.on("singleclick", (evt) => {
      this.setLocation(evt.coordinate);
      let view = this.map.getView();
      let viewResolution = view.getResolution();

      let source = undefined;
      let sourceLoaiDat = undefined;
      switch (this.props.type) {
        case "KienTruc":
          source = this.BaseLayer.KienTruc.getSource();
          break;

        case "QHC":
          source = this.BaseLayer.QHC_Polygon.getSource();
          break;

        case "QHCT":
          source = this.BaseLayer.QHCT_RanhGioi.getSource();
          if (!this.state.checkedBanDoGiay) {
            sourceLoaiDat = this.BaseLayer.QHCT_Polygon.getSource();
          }
          break;

        case "QHPK":
          source = this.BaseLayer.QHPK_RanhGioi.getSource();
          if (!this.state.checkedBanDoGiay) {
            sourceLoaiDat = this.BaseLayer.QHPK_Polygon.getSource();
          }
          break;
        default:
          break;
      }

      if (source) {
        let url = source.getGetFeatureInfoUrl(
          evt.coordinate,
          viewResolution,
          view.getProjection(),
          {
            INFO_FORMAT: "application/geojson",
            FEATURE_COUNT: "50",
          }
        );
        this.clickMapSearch(url);
      }

      if (sourceLoaiDat && !this.state.checkedBanDoGiay) {
        let url = sourceLoaiDat.getGetFeatureInfoUrl(
          evt.coordinate,
          viewResolution,
          view.getProjection(),
          {
            INFO_FORMAT: "application/geojson",
            FEATURE_COUNT: "50",
          }
        );
        this.getLoaiDat(url);
        this._coordinateOverlay = evt.coordinate;
      }
    });

    setTimeout(() => {
      this.map.updateSize();
    }, 1);
  }

  async showOverLayeInfo(data) {
    let _contentPopup = document.getElementById("popup-content");
    if (this.props.type === "QHCT") {
      let TenDuAn = "-";
      let dataDuAn = undefined
      if (this.props.type === "QHCT" && this.props.listDuAn) {
        if (data && data.OBJECTID) {
          let res = await AxiosGetSecretApi(
            `/api/duanqh/getById-mb?ID=${data.OBJECTID}`
          );
          if (res && res.length !== 0) {
            dataDuAn = res[0]
            let duan = this.props.listDuAn.filter(
              (e) => e.Madoan === data.MaDuAn
            );
            if (duan.length > 0) TenDuAn = duan[0].Tendoan;
          }
        }
      }
      _contentPopup.innerHTML =
        '<div class="header-title-popup">Thông tin chi tiết mặt bằng quy hoạch</div>' +
        "</hr>" +
        `<div style="display: flex;">
            <div class="text-title-popup">Tên dự án:</div>
            <div class="text-content-popup">${TenDuAn}</div>
        </div> 
  
        <div style="display: flex;">
            <div class="text-title-popup">Tên loại đất:</div>
            <div class="text-content-popup">${
              dataDuAn.TenLoaiDat ? dataDuAn.TenLoaiDat : "-"
            }</div>
        </div> 
  
        <div style="display: flex;">
            <div class="text-title-popup">Diện tích (m²):</div>
            <div class="text-content-popup">${
              dataDuAn && dataDuAn.DienTichFormat
              ? StaticClass.formatPrice(dataDuAn.DienTichFormat)
              : "-"
            }</div>
        </div> 
  
        <div style="display: flex;">
            <div class="text-title-popup">Mô tả:</div>
            <div class="text-content-popup">${dataDuAn.MoTa ? dataDuAn.MoTa : "-"}</div>
        </div> `;
      this._overlayPopup.setPosition(this._coordinateOverlay);
      return;
    }

    if (this.props.type === "QHPK") {
      let TenPhanKhu = "-";
      if (this.props.type === "QHPK" && this.props.listPhanKhu) {
        let duan = this.props.listPhanKhu.filter(
          (e) => e.OBJECTID == data.MaPhanKhu
        );
        if (duan.length > 0) TenPhanKhu = duan[0].TenPhanKhu;
      }
      _contentPopup.innerHTML =
        '<div class="header-title-popup">Thông tin chi tiết mặt bằng quy hoạch</div>' +
        "</hr>" +
        `<div style="display: flex;">
            <div class="text-title-popup">Tên phân khu:</div>
            <div class="text-content-popup">${TenPhanKhu}</div>
        </div> 
  
        <div style="display: flex;">
            <div class="text-title-popup">Tên loại đất:</div>
            <div class="text-content-popup">${
              data.TenLoaiDat ? data.TenLoaiDat : "-"
            }</div>
        </div> 
  
        <div style="display: flex;">
            <div class="text-title-popup">Diện tích (m²):</div>
            <div class="text-content-popup">${
              data.DienTich ? data.DienTich : "-"
            }</div>
        </div> 
  
        <div style="display: flex;">
            <div class="text-title-popup">Mô tả:</div>
            <div class="text-content-popup">${data.MoTa ? data.MoTa : "-"}</div>
        </div> `;
      this._overlayPopup.setPosition(this._coordinateOverlay);
      return;
    }
  }

  async clickMapSearch(url) {
    if (this._vectorSource) {
      this._vectorSource.clear();
    }
    if (this.state.checkedBanDoGiay) {
      this.getDuAnBanDoGiay(url);
    }
    let res = await AxiosGetSecretApi(url);
    if (
      res &&
      res.features &&
      Array.isArray(res.features) &&
      res.features.length !== 0 &&
      res.features[0].properties &&
      res.features[0].properties
    ) {
      if (this.props.type === "QHCT") {
        this.props.searchDataTable(res.features[0].properties.OBJECTID_1);
      } else {
        this.props.searchDataTable(res.features[0].properties.OBJECTID);
      }
    } else {
      message.error("Chưa có thông tin dự án");
    }
  }

  async getImageBanDoGiay(url) {
    let res = await AxiosGetSecretApi(url);
    if (res && Array.isArray(res) && res.length > 0 && res[0].URL) {
      this.setState({
        isShowButtonMap: true,
      });
      let extent = [res[0].Left, res[0].Bottom, res[0].Right, res[0].Top];
      extent = ol.proj.transformExtent(
        extent,
        ol.proj.get("EPSG:4326"),
        ol.proj.get("EPSG:3857")
      );

      this.map.getView().setCenter(ol.extent.getCenter(extent));
      // setTimeout(() => {
      //   this._overlayPopup.setPosition(this.map.getView().getCenter());
      // }, 100);
      this.map.getView().fit(extent, this.map.getSize(), { duration: 2000 });

      this._imgOvelayerLink = res[0].URL + "/" + res[0].Name;
      if (this._imgLayer) {
        this._imgLayer.setSource(
          new ol.source.ImageStatic({
            url: res[0].URL + "/" + res[0].Name,
            imageExtent: extent,
            // imageLoadFunction: (image, url) =>{
            // }
          })
        );
      } else {
        this._imgLayer = new ol.layer.Image({
          source: new ol.source.ImageStatic({
            url: res[0].URL + "/" + res[0].Name,
            imageExtent: extent,
          }),
        });
        this.map.getLayers().push(this._imgLayer);
      }
      return;
    }
    if (this._imgLayer) {
      this._imgLayer.setSource(undefined);
    }
    this.setState({
      isShowButtonMap: false,
    });
    message.error("Không có thông tin bản đồ giấy");
  }

  async getDuAnBanDoGiay(url) {
    let res = await AxiosGetSecretApi(url);
    if (
      res &&
      res.features &&
      res.features &&
      Array.isArray(res.features) &&
      res.features.length > 0
    ) {
      let poly = res.features[res.features.length - 1];
      // let poly = res.features[0];
      if (this.props.type === "QHCT") {
        if (
          poly.properties &&
          poly.properties.Madoan &&
          poly.properties.Madoan !== "null" &&
          poly.properties.Madoan !== "Null"
        ) {
          let urlImg = `/api/ban-do-giay/tim-theo-ma?code=${poly.properties.Madoan}`;
          this.imgFullMap = `/api/ban-do-giay/tim-theo-ma?code=${poly.properties.Madoan}a`;
          this.getImageBanDoGiay(urlImg, poly);
          return;
        }
      }

      if (this.props.type === "QHPK") {
        if (
          poly.properties &&
          poly.properties.MaPhanKhu &&
          poly.properties.MaPhanKhu !== "null" &&
          poly.properties.MaPhanKhu !== "Null"
        ) {
          let urlImg = `/api/ban-do-giay/tim-theo-ma-pk?code=${poly.properties.MaPhanKhu}`;
          this.imgFullMap = `/api/ban-do-giay/tim-theo-ma-pk?code=${poly.properties.MaPhanKhu}a`;
          this.getImageBanDoGiay(urlImg, poly);
          return;
        }
      }
    }

    message.error("Không có thông tin bản đồ");
  }

  addPrivateLayers() {
    // quy hoach chi tiet
    this.BaseLayer.QHCT_Polygon = new ol.layer.Tile({
      visible: false,
      source: new ol.source.TileWMS({
        url: domainMap + "/SoXayDung/QuyHoachDoThi/MapServer/WMSServer",
        crossOrigin: "Anonymous",
        params: {
          LAYERS: "4",
          FORMAT: "image/png",
        },
      }),
    });

    this.BaseLayer.QHCT_Line = new ol.layer.Tile({
      visible: false,
      source: new ol.source.TileWMS({
        url: domainMap + "/SoXayDung/QuyHoachDoThi/MapServer/WMSServer",
        crossOrigin: "Anonymous",
        params: {
          LAYERS: "8",
          FORMAT: "image/png",
        },
      }),
    });

    this.BaseLayer.QHCT_RanhGioi = new ol.layer.Tile({
      visible: this.props.type === "QHCT" ? true : false,
      source: new ol.source.TileWMS({
        url: domainMap + "/SoXayDung/QuyHoachDoThi/MapServer/WMSServer",
        crossOrigin: "Anonymous",
        params: {
          LAYERS: "1",
          FORMAT: "image/png",
        },
      }),
    });

    // quy hoach phan khu
    this.BaseLayer.QHPK_Polygon = new ol.layer.Tile({
      visible: false,
      source: new ol.source.TileWMS({
        url: domainMap + "/SoXayDung/QuyHoachDoThi/MapServer/WMSServer",
        crossOrigin: "Anonymous",
        params: {
          LAYERS: "2",
          FORMAT: "image/png",
        },
      }),
    });

    this.BaseLayer.QHPK_Line = new ol.layer.Tile({
      visible: false,
      source: new ol.source.TileWMS({
        url: domainMap + "/SoXayDung/QuyHoachDoThi/MapServer/WMSServer",
        crossOrigin: "Anonymous",
        params: {
          LAYERS: "6",
          FORMAT: "image/png",
        },
      }),
    });

    this.BaseLayer.QHPK_RanhGioi = new ol.layer.Tile({
      visible: this.props.type === "QHPK" ? true : false,
      source: new ol.source.TileWMS({
        url: domainMap + "/SoXayDung/QuyHoachDoThi/MapServer/WMSServer",
        crossOrigin: "Anonymous",
        params: {
          LAYERS: "0",
          FORMAT: "image/png",
        },
      }),
    });

    // quy hoach chung
    this.BaseLayer.QHC_Polygon = new ol.layer.Tile({
      visible: false,
      source: new ol.source.TileWMS({
        url: domainMap + "/SoXayDung/QuyHoachDoThi/MapServer/WMSServer",
        crossOrigin: "Anonymous",
        params: {
          LAYERS: "3",
          FORMAT: "image/png",
        },
      }),
    });

    this.BaseLayer.QHC_Line = new ol.layer.Tile({
      visible: false,
      source: new ol.source.TileWMS({
        url: domainMap + "/SoXayDung/QuyHoachDoThi/MapServer/WMSServer",
        crossOrigin: "Anonymous",
        params: {
          LAYERS: "7",
          FORMAT: "image/png",
        },
      }),
    });

    this.BaseLayer.KienTruc = new ol.layer.Tile({
      visible: true,
      source: new ol.source.TileWMS({
        url: domainMap + "/SoXayDung/QuyHoachDoThi/MapServer/WMSServer",
        crossOrigin: "Anonymous",
        params: {
          LAYERS: "5",
          FORMAT: "image/png",
        },
      }),
    });
  }

  // get data loai dat

  async getLoaiDat(url) {
    let res = await AxiosGetSecretApi(url);
    if (
      res &&
      res.features &&
      Array.isArray(res.features) &&
      res.features.length !== 0 &&
      res.features[0].properties &&
      res.features[0].properties
    ) {
      this.setState({
        dataLoaiDat: res.features[0].properties,
      });

      this.showOverLayeInfo(res.features[0].properties);
    }
  }

  //get data - -   - -  - -  - -  - -  - -  - -  - -  - -  - -  - -  - -  - -  - -  - -  - -  - -  - -  - -

  drawPolygon = (SHAPE) => {
    let feature;
    //draw line
    let dataPoints = SHAPE.points.map((e) => {
      let arrLocation = [e.x, e.y];
      arrLocation = proj4("EPSG:6959").inverse(arrLocation);
      arrLocation = ol.proj.transform(arrLocation, "EPSG:4326", "EPSG:3857");
      // console.log(proj4("EPSG:3857", "EPSG:4326", arrLocation))
      // console.log(arrLocation)

      return arrLocation;
    });
    feature = new ol.Feature({
      geometry: new ol.geom.LineString(dataPoints),
    });

    let vectorSource = new ol.source.Vector({
      features: [feature],
    });

    let aa = feature.getGeometry().getExtent();
    let oo = ol.extent.getCenter(aa);
    this._iconGeometry.setCoordinates(oo);
    this.map.getView().setCenter(oo);

    this.map.getView().fit(aa, this.map.getSize(), { duration: 2000 });

    if (this.map.getView().getZoom() > 21) {
      this.map.getView().setZoom(21);
    }

    if (this._vectorLayer) {
      this._vectorLayer.setSource(
        new ol.source.Vector({
          features: [feature],
        })
      );
    } else {
      this._vectorLayer = new ol.layer.Vector({
        source: vectorSource,
      });
      this.map.getLayers().push(this._vectorLayer);
    }
  };

  drawRing = (data) => {
    //draw line
    this.handleCloseClick("Map");

    if (data && data.length !== 0) {
      let listPoint = [];
      data.forEach((e) => {
        let x = new ol.Feature({
          geometry: new ol.geom.LineString(e),
        });
        listPoint.push(x);
      });

      let vectorSource = new ol.source.Vector({
        features: listPoint,
      });

      let aa = listPoint[0].getGeometry().getExtent();
      let oo = ol.extent.getCenter(aa);
      this._iconGeometry.setCoordinates(oo);
      this.map.getView().setCenter(oo);

      this.map.getView().fit(aa, this.map.getSize(), { duration: 2000 });

      if (this.map.getView().getZoom() > 21) {
        this.map.getView().setZoom(21);
      }

      if (this._vectorLayer) {
        this._vectorLayer.setSource(
          new ol.source.Vector({
            features: listPoint,
          })
        );
      } else {
        this._vectorLayer = new ol.layer.Vector({
          source: vectorSource,
          style: new ol.style.Style({
            fill: new ol.style.Fill({
              color: "rgba(255, 255, 255, 0.2)",
            }),
            stroke: new ol.style.Stroke({
              color: "#ffcc33",
              width: 4,
            }),
            image: new ol.style.Circle({
              radius: 7,
              fill: new ol.style.Fill({
                color: "#ffcc33",
              }),
            }),
          }),
        });
        this.map.getLayers().push(this._vectorLayer);
      }
    }
  };

  //SetStateAsync
  SetStateAsync(state) {
    return new Promise((resolve) => {
      this.setState(state, resolve);
    });
  }

  onChangeLayers = (value) => {
    // ban do so

    if (value === 3) {
      this._camLeTile.setVisible(true);
      // this.setVisibleChiaLo(true);
      if (this._imgLayer) this._imgLayer.setVisible(false);

      this.setState({
        _isDigitalMap: true,
        _isVisibleTabSearch: 1,
        _isShowBackground: true,
        isDisableButtonShowMapLayers: false,
      });
    }
    //ban do giay
    else if (value === 4) {
      this._camLeTile.setVisible(false);
      // this.setVisibleChiaLo(false);

      if (this._imgLayer) this._imgLayer.setVisible(true);

      this.setState({
        _isDigitalMap: false,
        _isVisibleTabSearch: 4,
        _isShowBackground: false,
        isDisableButtonShowMapLayers: true,
      });
    }
  };

  handleCloseClick = (e) => {
    this.resetSomeState();
    this.map.getView().setZoom(14);
    this.map.getView().setCenter([12045324.924720876, 1806357.9277613866]);

    if (this._vectorSource) {
      this._vectorSource.clear();
    }

    if (this._vectorLayer) {
      this._vectorLayer.getSource().clear();
    }
    this._iconGeometry.setCoordinates([12045324.924720876, 1806357.9277613866]);
  };

  resetSomeState = () => {
    this.setState({
      isShowSearchResult: false,
      currentIndex: null,
    });
  };

  onShowFullImg = async () => {
    let res = await AxiosGetSecretApi(this.imgFullMap);
    if (res && res.length > 0) {
      this.srcImg = `${res[0].URL}/${res[0].Name}`;
      this.setState({
        isShowModal: true,
      });
    } else {
      message.error("Chưa có thông tin (dữ liệu đang cập nhật)");
    }
  };

  onShowShortedImg = () => {
    // this.fetImgOverlay(this._urlImageOverlay);
    this.setState({
      _isShowFullImg: false,
    });
  };

  onDownloadImgOverlay = () => {
    let self = this;
    window.open(self._imgOvelayerLink, "_blank");
  };

  disableLayerBanDoGiay() {
    let check = this.state.checkedBanDoGiay;
    switch (this.props.type) {
      case "QHCT":
        this.BaseLayer.QHCT_Polygon.setVisible(!check);
        this.BaseLayer.QHCT_Line.setVisible(!check);
        this.BaseLayer.QHCT_RanhGioi.setVisible(check);
        break;

      case "QHPK":
        this.BaseLayer.QHPK_Polygon.setVisible(!check);
        this.BaseLayer.QHPK_Line.setVisible(!check);
        this.BaseLayer.QHPK_RanhGioi.setVisible(check);
        break;

      case "QHC":
        this.BaseLayer.QHC_Polygon.setVisible(!check);
        this.BaseLayer.QHC_Line.setVisible(!check);
        break;

      case "KienTruc":
        this.BaseLayer.KienTruc.setVisible(!check);
        break;

      default:
        break;
    }
  }

  render() {
    return (
      <div
        id="do-an-quy-hoach"
        className="map-quy-hoach"
        style={{ position: "relative" }}
      >
        <div className="map-bound " id="map-bound">
          <div id="map" className="map quy-hoach-ol-map" ref="map ">
            <button className="button-location btn-geo-on-map map-control-button">
              <i className="fas fa-location-arrow"></i>
            </button>

            <Dropdown
              overlay={
                <Menu className="menu-layer">
                  <Menu.Item key="VeTinh">
                    <div className="fl-bw">
                      <div className="text">Vệ tinh</div>
                      <Switch
                        checked={this.state.checkedVeTinh}
                        onChange={(data) => {
                          if (this.state.checkedBanDo && data) {
                            this._layers[0].setVisible(false);
                            this._layers[1].setVisible(true);
                            this.setState({
                              checkedVeTinh: data,
                              checkedBanDo: false,
                            });
                            return;
                          }
                          if (data) {
                            this._layers[0].setVisible(false);
                            this._layers[1].setVisible(true);
                          } else {
                            this._layers[0].setVisible(false);
                            this._layers[1].setVisible(false);
                          }
                          this.setState({ checkedVeTinh: data });
                        }}
                      ></Switch>
                    </div>
                  </Menu.Item>
                  <Menu.Divider />

                  <Menu.Item key="BanDo">
                    <div className="fl-bw">
                      <div className="text">Đường phố</div>
                      <Switch
                        checked={this.state.checkedBanDo}
                        onChange={(data) => {
                          if (this.state.checkedVeTinh && data) {
                            this._layers[1].setVisible(false);
                            this._layers[0].setVisible(true);
                            this.setState({
                              checkedBanDo: data,
                              checkedVeTinh: false,
                            });
                            return;
                          }
                          if (data) {
                            this._layers[1].setVisible(false);
                            this._layers[0].setVisible(true);
                          } else {
                            this._layers[1].setVisible(false);
                            this._layers[0].setVisible(false);
                          }
                          this.setState({ checkedBanDo: data });
                        }}
                      ></Switch>
                    </div>
                  </Menu.Item>

                  {/* <Menu.Item key="BanDoGiay">
                    <Dropdown
                      overlay={
                        <Menu className="menu-ban-do-giay">
                          <Menu.Item key="500">
                            <div className="fl-bw">
                              <div className="text">
                                Quy hoạch chi tiết 1/500
                              </div>
                              <Switch
                                checked={this.state.BDGiay_500}
                                onChange={(value) => {
                                  this.onChangeBanDoGiay500(value);
                                }}
                              ></Switch>
                            </div>
                          </Menu.Item>
                          <Menu.Divider />

                          <Menu.Item key="5000">
                            <div className="fl-bw">
                              <div className="text">
                                Quy hoạch phân khu 1/5000
                              </div>
                              <Switch
                                checked={this.state.BDGiay_5000}
                                onChange={(value) => {
                                  this.onChangeBanDoGiay5000(value);
                                }}
                              ></Switch>
                            </div>
                          </Menu.Item>
                          <Menu.Divider />

                          <Menu.Item key="10000">
                            <div className="fl-bw">
                              <div className="text">
                                Quy hoạch chung 1/10000
                              </div>
                              <Switch
                                checked={this.state.BDGiay_10000}
                                onChange={(value) => {
                                  this.changeBanDoGiay10000(value);
                                }}
                              ></Switch>
                            </div>
                          </Menu.Item>
                        </Menu>
                      }
                    >
                      <div className="fl-bw">
                        <div className="text">Bản đồ giấy</div>
                        <i className="fas fa-caret-down"></i>
                      </div>
                    </Dropdown>
                  </Menu.Item> */}

                  {this.props.type !== "KienTruc" ? (
                    <>
                      <Menu.Divider />
                      <Menu.Item>
                        <div className="fl-bw">
                          <div className="text">Bản đồ giấy</div>
                          <Switch
                            checked={this.state.checkedBanDoGiay}
                            onChange={(value) => {
                              this.setState({ checkedBanDoGiay: value });
                            }}
                          ></Switch>
                        </div>
                      </Menu.Item>
                    </>
                  ) : null}
                </Menu>
              }
              trigger={["click"]}
            >
              <Tooltip title="Chuyển đổi nền" placement="bottomRight">
                <button className="button-layer map-control-button">
                  <i className="fas fa-map"></i>
                </button>
              </Tooltip>
            </Dropdown>

            {this.state.isShowButtonMap && this.state.checkedBanDoGiay ? (
              <div className="div-show-full">
                <Button
                  className="btn-show-full-img"
                  onClick={this.onShowFullImg}
                  type="primary"
                >
                  Xem đầy đủ
                </Button>

                <Button
                  className="btn-show-full-img"
                  onClick={this.onDownloadImgOverlay}
                  type="primary"
                >
                  Tải về
                </Button>
              </div>
            ) : null}

            {this.state.isShowModal && (
              <Modal
                visible={this.state.isShowModal}
                onCancel={() => {
                  this.setState({ isShowModal: false });
                }}
                footer={null}
                width={800}
              >
                <img
                  // src={`https://sxd.sgmcvietnam.vn${this.srcImg}`}
                  src={`${domainMap}${this.srcImg}`}
                  style={{ width: "800px", height: "auto" }}
                  alt=" "
                ></img>
              </Modal>
            )}
          </div>
        </div>
        {/* {this.state._isShowImgOverlay &&
          !this.state._isShowFullImg &&
          !this.state._isDigitalMap && (
            <div className="div-show-full">
              <Button
                className="btn-show-full-img"
                onClick={this.onShowFullImg}
                type="primary"
              >
                Xem đầy đủ
              </Button>
            </div>
          )} */}

        <div id="popup" className="ol-popup">
          <a href="#" id="popup-closer" className="ol-popup-closer" />
          <div id="popup-content" />
        </div>
      </div>
    );
  }
}

export default MapQuyHoach;
